module.exports = __webpack_public_path__ + "static/media/location.a4ba60b5.svg";